import React, { useState } from 'react';
import toast from "react-hot-toast";
import { HiTrash } from "react-icons/hi";
import { useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import Spinner from '../../../Component/Spinner/Spinner';
import useScrollToTop from '../../../hooks/useScrollToTop';
import useTitle from '../../../hooks/useTitle';
import ConfirmationModal from '../../Shared/ConfirmationModal/ConfirmationModal';

const Category = () => {
    const [deletingCategory, setDeletingCategory] = useState(null);

    useScrollToTop();
    useTitle("Product Category");
    const navigate = useNavigate();

    const closeModal = () => {
        setDeletingCategory(null);
    };

    const {
        data: categories = [],
        refetch,
        isLoading,
    } = useQuery({
        queryKey: ["categories"],
        queryFn: async () => {
            const res = await fetch(
                `${process.env.REACT_APP_API_URL}/category`
            );
            const data = await res.json();
            if (data.success) {
                return data.data;
            } else {
                return [];
            }
        },
    });

    const handleDeleteCategory = (id) => {
        fetch(`${process.env.REACT_APP_API_URL}/category/${id}`, {
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${localStorage.getItem("token")}`,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    toast.success(data.message);
                } else {
                    toast.error(data.error);
                }
                refetch();
            });
    };

    if (isLoading) {
        return <Spinner />;
    }

    return (
        <div className="px-5">
            <div className="flex flex-wrap gap-5">
                <h4 className="mb-4 text-2xl font-semibold text-gray-600 dark:text-gray-300">
                    All Product Category
                </h4>
                <button
                    className="mb-4 btn btn-warning btn-xs"
                    onClick={() => navigate("/dashboard/add-category")}
                >
                    Add New Category
                </button>
            </div>
            <div className="w-full overflow-hidden rounded-lg shadow-xs">
                <div className="w-full overflow-x-auto">
                    <table className="w-full whitespace-no-wrap ">
                        <thead>
                            <tr className="text-xs font-semibold tracking-wide text-left text-gray-700 uppercase border-b dark:border-gray-700 bg-gray-300 dark:text-gray-400 dark:bg-black">
                                <th className="px-4 py-3">Category</th>
                                <th className="px-4 py-3">Actions</th>
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-900">
                            {categories?.map((category) => (
                                <tr
                                    className="text-gray-700 dark:text-gray-400"
                                    key={category?._id}
                                >
                                    <td className="px-4 py-3">
                                        <div className="flex items-center text-sm">
                                            {/* <!-- Avatar with inset shadow --> */}
                                            <div className="relative hidden w-8 h-8 mr-3 rounded-full md:block">
                                                <img
                                                    className="object-cover w-full h-full rounded-full"
                                                    src={category?.image}
                                                    alt=""
                                                    loading="lazy"
                                                />
                                                <div
                                                    className="absolute inset-0 rounded-full shadow-inner"
                                                    aria-hidden="true"
                                                ></div>
                                            </div>
                                            <div>
                                                <p className="font-semibold">{category?.categoryName}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td className="px-4 py-3">
                                        <div className="flex items-center space-x-3 text-sm">
                                            <label
                                                htmlFor="confirmation-modal"
                                                className="flex items-center justify-between py-2 text-sm font-medium leading-5 text-blue-700 rounded-lg dark:text-gray-400 dark:hover:text-white hover:text-blue-900 focus:outline-none focus:shadow-outline-gray cursor-pointer"
                                                aria-label="Delete"
                                                title="Delete This category"
                                                onClick={() => setDeletingCategory(category._id)}
                                            >
                                                <HiTrash className="w-5 h-5" />
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                {deletingCategory && (
                    <ConfirmationModal
                        title={`Are you sure you want to delete?`}
                        message={`If you want to delete . It cannot be undone.`}
                        successAction={handleDeleteCategory}
                        successButtonName="Delete"
                        modalData={deletingCategory}
                        closeModal={closeModal}></ConfirmationModal>
                )}
            </div>
        </div>
    );
};

export default Category;